export default __webpack_public_path__ + "static/media/cat.21996071.svg";